export class DebitoAutomaticoContrato {
  /**
   * Numero contrato
   */
  nuContrato: number = 0;
  /**
   * Optin limite
   */
  optinLimite: string = "";
  /**
   * Optin vencida
   */
  optinVencida: string = "";
  /**
   * Optin tipo transacao
   */
  tipoTransacao: string = "";

  cdMsgemRetorno: string;
  dsMsgemRetorno: string;

  constructor() { }
}

export class DebitoAutomaticoRequest {
  nuCTRL: string;
  nuContrato: string;
  optinLimite: string;
  optinVencida: string;
  constructor() {
  }
}




// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/modelo/debito-automatico-contrato.ts